module.exports = __webpack_public_path__ + "static/junit5-7d743e75af406b2e7946853ba38a8de6.png";